
export function wrapIpfs(url) {
    return url.replace('ipfs://', 'https://ipfs.io/ipfs/');
}

